import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiPlay } from 'react-icons/fi';
import './Hero.css';

const Hero: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="hero" aria-label="Hero section">
      <div className="hero-split">
        {/* Sol Taraf - İçerik */}
        <div className="hero-left">
          {/* Dekoratif elementler */}
          <motion.div 
            className="hero-decoration hero-decoration-1"
            animate={{ 
              scale: [1, 1.1, 1],
              opacity: [0.3, 0.5, 0.3]
            }}
            transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
            aria-hidden="true"
          />
          <motion.div 
            className="hero-decoration hero-decoration-2"
            animate={{ 
              rotate: [45, 55, 45],
              opacity: [0.2, 0.4, 0.2]
            }}
            transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
            aria-hidden="true"
          />
          <motion.div 
            className="hero-decoration hero-decoration-3"
            animate={{ 
              scale: [1, 1.5, 1],
              opacity: [0.5, 1, 0.5]
            }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
            aria-hidden="true"
          />

          <motion.div 
            className="hero-content"
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            {/* Badge */}
            <motion.div 
              className="hero-badge"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
            >
              <span className="badge-dot"></span>
              <span>{t('hero.badge')}</span>
            </motion.div>

            {/* Başlık */}
            <motion.h1 
              className="hero-title"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
            >
              {t('hero.title')}
            </motion.h1>

            {/* Alt başlık */}
            <motion.p 
              className="hero-subtitle"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
            >
              {t('hero.subtitle')}
            </motion.p>

            {/* Butonlar */}
            <motion.div 
              className="hero-buttons"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 }}
            >
              <Link to="/packages" className="btn btn-primary" aria-label={t('hero.packages')}>
                <FiPlay aria-hidden="true" />
                {t('hero.packages')}
              </Link>
              <Link to="/contact" className="btn btn-secondary" aria-label={t('nav.contact')}>
                {t('nav.contact')}
                <FiArrowRight aria-hidden="true" />
              </Link>
            </motion.div>
          </motion.div>
        </div>

        {/* Sağ Taraf - Fotoğraf */}
        <motion.div 
          className="hero-right"
          initial={{ opacity: 0, scale: 1.1 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <div className="hero-separator" aria-hidden="true"></div>
          <img 
            src="/hero1.jpeg" 
            alt="UstaConsulting Founder - Mert Usta" 
            className="hero-image"
          />
        </motion.div>
      </div>

      {/* Scroll İndikatör */}
      <div className="hero-scroll" aria-hidden="true">
        <div className="scroll-indicator">
          <div className="scroll-dot"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
